<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save()"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="75%"
    :loadingContent="loading"
    :showConfirmButton="!loading"
  >
    <SearchCriteriaBuilder
      :ref="searchCriteriaBuilderKey"
      :contentTypeIDs="contentTypeIDs"
      :canUseVariables="canUseVariables"
      :onlyShowVisibleFields="onlyShowVisibleFields"
    />
  </base-modal>
</template>
<script>
import SearchCriteriaBuilder from '@/components/search/SearchCriteriaBuilder.vue';
export default {
    name: 'SearchCriteriaBuilderModal',
    components: {
        SearchCriteriaBuilder,
    },
    props: {
        contentTypeIDs: {
            type: Array,
            default: () => [],
        },
        allowEmptyCondition: {
            type: Boolean,
            default: false,
        },
        canUseVariables: {
            type: Boolean,
            default: true,
        },
        onlyShowVisibleFields: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            modal: {
                title: this.$t('Condition'),
                key: 'searchCriteriaBuilderModalKey',
            },
            open: false,
            searchCriteriaBuilderKey: 'searchCriteriaBuilderKey',
            loading: false,
        };
    },
    computed: {
        searchCriteriaBuilderInstance() {
            return this.$refs[this.searchCriteriaBuilderKey];
        },
    },
    methods: {
        edit(conditionStr) {
            this.show();
            setTimeout(async () => {
                await this.searchCriteriaBuilderInstance.edit(conditionStr);
            }, 10);
        },
        save() {
            var condition = {
                conditionStr: this.searchCriteriaBuilderInstance.getConditionStr(),
                displayConditionStr: this.searchCriteriaBuilderInstance.getDisplayConditionStr(),
            };
            if (
                condition.conditionStr == 'INVALID' ||
                (condition.conditionStr == '' && !this.allowEmptyCondition)
            ) {
                return;
            } else {
                this.$emit('on-condition-saved', condition);
                this.hide();
            }
        },
        getDisplayConditionStr(conditionStr) {
            this.searchCriteriaBuilderInstance.getDisplayConditionStr(conditionStr);
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
